import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpService } from './services/http-service.service';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    HttpClientModule
  ],
  declarations: [],
  providers:
  [
    HttpService
  ],
  exports:[]
})
export class HttpModule {
  static forRoot(): ModuleWithProviders<HttpModule> {
    return {
      ngModule: HttpModule,
      providers: [
        ]
    };
  }
}
